import { gql, useQuery } from '@apollo/client'
import { DashboardTitle } from 'components/Dashboard/DashboardTitleContext'
import PageComponent from 'components/Dashboard/PageComponent'
import { flatten, uniq } from 'lodash'
import { FaCheck } from 'react-icons/fa'
import { StaticDiscountCodesQuery } from './__generated__/StaticDiscountCodesQuery'

const staticDiscountCodesQuery = gql`
  query StaticDiscountCodesQuery {
    staticDiscountCodes {
      id
      skus
      description
      percentDiscount
    }
  }
`
const StaticDiscountCodes: PageComponent = () => {
  const { loading, error, data } = useQuery<StaticDiscountCodesQuery>(staticDiscountCodesQuery)

  if (loading) return <p>Loading...</p>

  if (error) throw error

  const allSkus = uniq(flatten(data.staticDiscountCodes.map((code) => code.skus)))

  return (
    <div className="container">
      <DashboardTitle title="Static Discount Codes" />

      <table className="table is-bordered is-fullwidth">
        <thead>
          <tr>
            <th>Code</th>
            <th>Percent</th>
            <th>
              Description
              <br />
              (Shown in cart)
            </th>
            {allSkus.map((sku) => (
              <th key={sku}>{sku}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.staticDiscountCodes.map((code) => (
            <tr key={code.id}>
              <td>{code.id.toUpperCase()}</td>
              <td>{code.percentDiscount}</td>
              <td>{code.description}</td>
              {allSkus.map((sku) => (
                <td key={sku} className="has-text-centered">
                  {code.skus.includes(sku) ? <FaCheck /> : null}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

StaticDiscountCodes.displayName = 'Static Discount Codes'
StaticDiscountCodes.path = '/static-discount-codes'

export default StaticDiscountCodes
